import OrderCreate from './pages/OrderCreate';
import OrderDetails from './pages/OrderDetails';
import DeliveryDetails from './pages/DeliveryDetails';
import Cancelled from './pages/Cancelled';
import Approved from './pages/Approved';
import BankAgreement from './pages/BankAgreement';
import Error from './pages/ErrorPage';

export default [
  { path: '/', redirect: '/order-create' },
  {
    path: '/order-create',
    component: OrderCreate,
    name: '1',
    meta: { title: 'Bestellübersicht | Auto-Kredit bei Bank11 vereinbaren' },
  },
  {
    path: '/order-details',
    component: OrderDetails,
    name: '2',
    meta: { title: 'PKW.de | Bestellstatus' },
  },
  {
    path: '/delivery-details',
    component: DeliveryDetails,
    name: '3',
    meta: { title: 'PKW.de | Details zur Lieferung' },
  },
  {
    path: '/cancelled',
    component: Cancelled,
    name: '4',
    meta: { title: 'PKW.de | Ihre Bestellung wurde storniert' },
  },
  {
    path: '/approved',
    component: Approved,
    name: '5',
    meta: { title: 'PKW.de | Ihre Bestellung wurde bestätigt' },
  },
  {
    path: '/bank-agreement',
    component: BankAgreement,
    name: 'bankAgreement',
    meta: { title: 'PKW.de | Ihre Bestellung wurde bestätigt' },
  },
  {
    path: '/error',
    component: Error,
    name: 'error',
    meta: { title: 'Es ist ein Fehler aufgetreten' },
  },
];
